import React from "react";
import "./BlogsPageUI.css";

import useMeta from '../../../hooks/useMeta'

import Navbar from "../../../CommonComponent/Navbar/Navbar";
import Footer from "../../../CommonComponent/Footer/footer";
import NotificationBar from "../../../CommonComponent/Notification/NotificationBar";

import { useParams } from "react-router-dom";
import { BlogsPost_Data } from '../BlogsPost_Data';

const BlogPost_UI = () => {
    const { Blog_Posts } = useParams();
    const Currnt_Blog_Post_Data = BlogsPost_Data[Blog_Posts];
    const B_Post = Currnt_Blog_Post_Data ?? null;

    const PostTitle = B_Post?.Blog_Title || null;
    const PostContent = B_Post?.Blog_post_content || null;

    const Meta_title = B_Post?.Meta_title || null;
    const OG_title = B_Post?.OG_title || null;
    const Meta_Description = B_Post?.Meta_Description || null;
    const OG_Description = B_Post?.OG_Description || null;
    const Meta_OG_URl = B_Post?.Meta_OG_URl || null;

    useMeta({
        title: Meta_title,
        description: Meta_Description,
        canonical: Meta_OG_URl,
        og: {
            locale: 'en_US',
            type: 'article',
            title: OG_title,
            description: OG_Description,
            url: Meta_OG_URl,
            site_name: 'Marvel Blinds',
        },
    });

    return (
        <>
            <Navbar />
            <NotificationBar />

            <div className="blog_p-container">
                <div className="blog_p-wrapper">
                    <div className="blog_p-content">
                        {PostTitle && <h1 className="blog_p-title">{PostTitle}</h1>}
                        {PostContent}
                    </div>
                </div>
            </div>

            <Footer />
        </>
    );
}

export default BlogPost_UI;
